import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { saveMenuAuthData, saveMultiLangData } from "../../store/action";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import idIcon from "../../assets/images/ico_id.png";
import pwIcon from "../../assets/images/ico_pw.png";
import loginTop from "../../assets/images/bg_login_top.jpg";
import arrowIcon from "../../assets/images/ico_arrow.gif";
import api from "../../services/api";
import SearchInput from "../../components/common/SearchInput";
import LoginButton from "../../components/common/LoginButton";
import Footer from "../../layout/Footer";
import MessageDialog from "../../components/common/MessageDialog";
import FunctionButton from "../../components/common/FunctionButton";
import SimpleHeader from "../../layout/SimpleHeader";
import LoginInputWrapDiv from "../../components/common/LoginInputWrapDiv";
import OtpAuthInline from "../../components/user/OtpAuthInline";
import OtpRegisterModal from "../../components/user/OtpRegisterModal";
import bgMobile from "../../assets/images/bg_mobile.gif";
import mobileIcon from "../../assets/images/ic_launcher.png";
import NoticePopupList from "../../components/notice/NoticePopupList";
import { POPUP_TARGET } from "../../services/NoticePopupUtil";
import { saveBlobAsFile } from "../../services/FileDownloadUtil";

const LoginVisualWrap = styled.div`
  text-align: center;
  background: url(${loginTop}) no-repeat;
  width: 100%;
  padding: 0;
  height: 324px;
  background-size: cover;

  > div {
    background-color: rgba(255, 255, 255, 0.6);
    margin: 0 60px;
    height: 274px;
    background-size: cover;
    position: relative;
    top: 50px;
    text-align: center;
  }

  .title {
    display: table;
    color: #000;
    font-size: 50px;
    font-weight: bold;
    width: 1120px;
    height: 100%;
    margin: 0 auto;
  }

  .title h1 {
    display: table-cell;
    vertical-align: middle;
    font-size: 50px;
    font-weight: bold;
  }

  .title h2 {
    font-size: 26px;
    position: relative;
    top: -5px;
  }
`;

const LinkWrap = styled.div`
  width: 526px !important;
  margin: 0 auto;

  table {
    width: 100%;
  }

  td {
    padding: 12px 10px 12px 0;
  }

  td a {
    font-size: 13px;
    color: #000;
  }

  td a:hover {
    text-decoration: underline;
  }

  td a:after {
    content: "";
    background: url(${arrowIcon}) no-repeat;
    width: 5px;
    height: 9px;
    display: inline-block;
    margin-left: 10px;
  }
`;

/* PC 로그인 화면의 앱 다운로드 버튼. 링크 표와 같은 너비로 맞춘다. */
const AppDownWrap = styled.div`
  width: 526px;
  margin: 10px auto 0;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 50px;
    border: 1px solid #002c5f;
    background: #fff;
    color: #002c5f;
    font-size: 15px;
    font-weight: bold;
    cursor: pointer;
  }

  button:hover {
    background: #f6f3f2;
  }

  button img {
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }
`;

const LinkMobile = styled.div`
  background: url(${bgMobile}) no-repeat;
  background-size: 100% 100%;
  padding: 2rem;
  font-size: 0.625em;
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0;
  display: -webkit-box;
  -webkit-box-pack: center;
  -webkit-box-align: center;

  h1 {
    position: absolute;
  }
  h1 img {
    width: 2.8rem;
    height: 1.4rem;
  }
  .app_down {
    background-color: #f6f3f2;
    padding: 6rem 0;
    text-align: center;
    width: 27rem;
  }
  .app_down p {
    font-size: 2.5rem;
    font-weight: bold;
  }
  .app_down dl img {
    width: 8.1rem;
    padding: 3rem 0 1rem;
  }
  .app_down span {
    display: block;
    font-size: 1.2rem;
  }
`;

/* Android 태블릿 UA 에는 "Mobile" 이 없으므로 Android 여부로만 판별한다. */
const isAndroidDevice = () => {
  return /Android/i.test(navigator.userAgent);
};

/* 로그인 단계. 서버 응답의 step 값으로만 바뀐다. */
const STEP_LOGIN = "LOGIN";
const STEP_OTP_AUTH = "OTP_AUTH";

const OTP_MODE_REGISTER = "REGISTER";
const OTP_MODE_REREGISTER = "REREGISTER";

const URL_MAIN = "/pdi-status/regional-record";
const URL_PW_CHANGE = "/join/changepw";

/* OTP API 결과 코드 -> 화면 문구 코드 */
const OTP_RESULT_MESSAGE = {
  1501: "L1114", // 코드 미입력
  1502: "L1111", // 자릿수 오류
  1503: "L1110", // 코드 불일치
  1504: "L1124", // 제한 시간 초과
  1505: "L1118", // Secret Key 조회·복호화 실패
  1506: "L1115", // Secret Key 저장 실패
  1507: "L1112", // 이미 사용한 코드 재사용 차단
};

/* 부분 인증을 폐기하고 로그인 화면으로 되돌려야 하는 결과 코드 */
const OTP_RESULT_DISCARD = [1504, 1505];

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [userId, setUserId] = useState("");
  const [userPwd, setUserPwd] = useState("");
  const [dialogMsg, setDialogMsg] = useState("");
  const [dialogMsg2, setDialogMsg2] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDialogOpen2, setIsDialogOpen2] = useState(false);

  /*
    OTP 임시 토큰은 sessionStorage 에 저장하지 않고 state 로만 들고 있는다.
    새로고침하면 사라지는 편이 요구사항(세션 만료 시 재로그인)에 맞다.
  */
  const [loginStep, setLoginStep] = useState(STEP_LOGIN);
  const [otpToken, setOtpToken] = useState("");
  const [prevOtpToken, setPrevOtpToken] = useState(""); // 재등록 취소 시 되돌릴 토큰
  const [otpMode, setOtpMode] = useState("");
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);
  const [otpAuthUri, setOtpAuthUri] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [otpCode, setOtpCode] = useState("");
  const [otpRegisterCode, setOtpRegisterCode] = useState("");
  const [remainSeconds, setRemainSeconds] = useState(0);
  const [otpMessage, setOtpMessage] = useState("");
  const [otpRegisterMessage, setOtpRegisterMessage] = useState("");
  const [afterAuthUrl, setAfterAuthUrl] = useState("");

  // 부분 인증 상태에서는 ID/PW 입력란과 로그인 버튼을 비활성화하되 화면에서 제거하지 않는다.
  const isPartialAuth = Boolean(otpToken);

  /*
    제한 시간의 만료 시각. 서버가 내려준 잔여 시간을 받은 시점에 고정한다.

    1초마다 1을 빼는 방식은 브라우저가 타이머를 늦추면(다른 탭으로 이동, 창 최소화, 절전)
    실제보다 시간이 많이 남은 것으로 표시된다. 만료 판정은 서버가 토큰 발급시각으로만 하므로
    화면에는 시간이 남았는데 인증이 거부되는 상태가 된다. 그래서 남은 시간을 시각 차이로 구한다.
  */
  const deadlineRef = useRef(0);

  /*
    OTP 등록 확인·인증 요청의 중복 전송 방지.
    엔터를 연달아 누르면 같은 코드로 요청이 두 번 나가고, 서버의 재사용 차단 때문에
    둘 중 하나는 반드시 실패한다. 응답 순서에 따라 로그인이 깨지므로 응답 전까지 다음 요청을 막는다.
    state 는 다음 렌더링 전까지 반영되지 않아 연속 입력을 막지 못하므로 ref 를 쓴다.
  */
  const otpSubmittingRef = useRef(false);

  /** 서버가 내려준 잔여 시간을 만료 시각으로 고정한다. */
  const startRemainCountdown = (seconds) => {
    const safeSeconds = Number(seconds) > 0 ? Number(seconds) : 0;

    deadlineRef.current = safeSeconds > 0 ? Date.now() + safeSeconds * 1000 : 0;
    setRemainSeconds(safeSeconds);
  };

  /** 제한 시간 표시를 비운다. 로그인 취소·만료·정식 토큰 발급 시 함께 호출한다. */
  const clearRemainCountdown = () => {
    deadlineRef.current = 0;
    setRemainSeconds(0);
  };

  // 잔여 시간 카운트다운. 표시 전용이며 만료 판정은 서버가 한다.
  useEffect(() => {
    if (!isPartialAuth) {
      return undefined;
    }

    const syncRemainSeconds = () => {
      if (!deadlineRef.current) {
        return;
      }
      setRemainSeconds(
        Math.max(0, Math.ceil((deadlineRef.current - Date.now()) / 1000))
      );
    };

    const timerId = setInterval(syncRemainSeconds, 1000);
    // 탭으로 돌아온 즉시 반영한다. 늦어진 타이머의 다음 틱까지 옛 값이 남는 것을 막는다.
    document.addEventListener("visibilitychange", syncRemainSeconds);
    window.addEventListener("focus", syncRemainSeconds);

    return () => {
      clearInterval(timerId);
      document.removeEventListener("visibilitychange", syncRemainSeconds);
      window.removeEventListener("focus", syncRemainSeconds);
    };
  }, [isPartialAuth]);

  useEffect(() => {
    if (isPartialAuth && remainSeconds === 0) {
      handleOtpTimeout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPartialAuth, remainSeconds]);

  const handleIdChange = (e) => {
    setUserId(e.target.value.trim());
  };

  const handlePwdChange = (e) => {
    setUserPwd(e.target.value.trim());
  };

  const handleOtpCodeChange = (e) => {
    setOtpCode(e.target.value.replace(/[^0-9]/g, ""));
  };

  const handleOtpRegisterCodeChange = (e) => {
    setOtpRegisterCode(e.target.value.replace(/[^0-9]/g, ""));
  };

  const activeEnter = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  /* 부분 인증 관련 상태를 모두 비운다. 로그인 취소와 제한 시간 초과가 같은 처리를 쓴다. */
  const resetPartialAuth = () => {
    setLoginStep(STEP_LOGIN);
    setOtpToken("");
    setPrevOtpToken("");
    setOtpMode("");
    setIsRegisterOpen(false);
    setOtpAuthUri("");
    setSecretKey("");
    setOtpCode("");
    setOtpRegisterCode("");
    clearRemainCountdown();
    setOtpMessage("");
    setOtpRegisterMessage("");
    setAfterAuthUrl("");
  };

  const showDialogMsg = (msg) => {
    setDialogMsg(msg);
    setIsDialogOpen(true);
  };

  const handleConfirm = () => {
    setIsDialogOpen(false);
  };

  /*
    비밀번호 변경 안내를 확인하면 서버가 지정한 화면으로 이동한다.
    서버가 내려준 이동 경로라도 그대로 믿지 않는다. 지금 이동 대상은
    비밀번호 변경 화면 하나뿐이라 그것과 비교해서 아니면 기본 경로로 보낸다.
  */
  const handleConfirm2 = () => {
    setIsDialogOpen2(false);

    const target = afterAuthUrl === URL_PW_CHANGE ? afterAuthUrl : URL_MAIN;

    navigate(target, { state: { userId: userId } });
  };

  /*
    정식 토큰을 받은 뒤의 공통 마무리.
    OTP 미사용 환경의 step=DONE 응답과 OTP 인증 성공 응답이 같은 형태의 토큰을 내려주므로 함께 쓴다.
  */
  const completeLogin = (token) => {
    if (
      !token ||
      !token.grantType ||
      !token.accessToken ||
      !token.refreshToken ||
      !token.menuAuth
    ) {
      showDialogMsg("Sorry. An unexpected error has occurred.");
      return;
    }

    const userInfo = {
      userId: userId,
      grantType: token.grantType,
      accessToken: token.accessToken,
      refreshToken: token.refreshToken,
      menuAuth: token.menuAuth,
    };
    sessionStorage.setItem("userInfo", JSON.stringify(userInfo));

    const nextUrl = token.afterAuthUrl;
    const nextMsg = token.afterAuthMsg;

    // 부분 인증 정보를 모두 비운다. 이후로는 정식 토큰만 쓴다.
    setOtpToken("");
    setPrevOtpToken("");
    setOtpCode("");
    clearRemainCountdown();
    setIsRegisterOpen(false);
    setLoginStep(STEP_LOGIN);

    api.post("/common/menuauth", {}).then((res) => {
      dispatch(saveMenuAuthData(res?.data));
    });
    api.post("/common/multilang", {}).then((res) => {
      dispatch(saveMultiLangData(res?.data));
    });

    // 비밀번호 변경이 필요한 계정은 사유를 안내한 뒤 변경 화면으로 보낸다.
    if (nextUrl) {
      setAfterAuthUrl(nextUrl);
      setDialogMsg2(nextMsg ? t(nextMsg) : "");
      setIsDialogOpen2(true);
      return;
    }

    navigate(URL_MAIN);
  };

  /* ===== 1차 인증 ===== */
  const handleLogin = () => {
    if (isPartialAuth) {
      return;
    }

    if (!userId || !userPwd) {
      showDialogMsg(t("L0008"));
      return;
    }

    api
      .post("/user/login", {
        userId: userId,
        userPwd: userPwd,
      })
      .then((response) => {
        const data = response?.data;

        if (!data || !data.step) {
          showDialogMsg("Sorry. An unexpected error has occurred.");
          return;
        }

        /*
          서버가 내려주는 step 값.
          evhc.otp-enabled 를 화면에 따로 두지 않는다. 서버가 "DONE" 을 주면 OTP 미사용
          환경이고, 그때는 1차 인증만으로 로그인이 끝나므로 정식 토큰이 함께 내려온다.
        */
        if (data.step === "DONE") {
          completeLogin(data.token);
          return;
        }

        if (data.step !== "OTP" || !data.otpToken) {
          showDialogMsg("Sorry. An unexpected error has occurred.");
          return;
        }

        setOtpToken(data.otpToken);
        startRemainCountdown(data.remainSeconds);

        if (data.otpRegistered) {
          enterOtpAuth();
        } else {
          // 미등록 계정은 등록을 먼저 끝내야 인증 단계로 갈 수 있다.
          openRegisterModal(OTP_MODE_REGISTER, data.otpToken);
        }
      })
      .catch((error) => {
        const result = error?.response?.data?.result;

        /*
          OTP 미사용 환경에서는 임시 비밀번호(1017)와 비밀번호 180일 초과(1019)를
          서버가 1차 인증 단계에서 바로 실패로 내려준다.
          OTP 사용 환경에서는 OTP 를 통과한 뒤 afterAuthUrl 로 안내하므로 여기로 오지 않는다.
        */
        if (result === 1017 || result === 1019) {
          setAfterAuthUrl(URL_PW_CHANGE);
          setDialogMsg2(t(result === 1017 ? "L0037" : "L0242"));
          setIsDialogOpen2(true);
          return;
        }

        if (result === 1012) {
          showDialogMsg(t("L0009"));
        } else if (result === 1016) {
          showDialogMsg(t("L0017"));
        } else if (result === 1013) {
          showDialogMsg(t("L0010"));
        } else if (result === 1018) {
          showDialogMsg(t("L0044"));
        } else if (result === 1015) {
          showDialogMsg(t("L0011"));
        } else if (result === 1505) {
          // OTP 등록 여부 조회 실패. 로그인을 진행하지 않는다.
          showDialogMsg(t("L1118"));
        } else {
          showDialogMsg("Sorry. An unexpected error has occurred.");
        }
      });
  };

  const enterOtpAuth = () => {
    setOtpCode("");
    setOtpMessage("");
    setIsRegisterOpen(false);
    setLoginStep(STEP_OTP_AUTH);
  };

  /*
    OTP API 오류 처리.
    제한 시간 초과와 조회 실패는 부분 인증을 폐기하고, 나머지는 단계를 유지한 채 재입력을 받는다.
  */
  const handleOtpError = (error, target) => {
    const result = error?.response?.data?.result;
    const messageCode = OTP_RESULT_MESSAGE[result];

    if (!messageCode) {
      resetPartialAuth();
      showDialogMsg("Sorry. An unexpected error has occurred.");
      return;
    }

    if (OTP_RESULT_DISCARD.includes(result)) {
      resetPartialAuth();
      showDialogMsg(t(messageCode));
      return;
    }

    if (target === "modal") {
      setOtpRegisterMessage(t(messageCode));
    } else {
      setOtpMessage(t(messageCode));
    }
  };

  /* ===== OTP 등록 / 재등록 ===== */
  const openRegisterModal = (mode, token) => {
    api
      .post("/user/otp/register/begin", {
        otpToken: token,
        mode: mode,
      })
      .then((response) => {
        const data = response?.data;

        if (!data || !data.otpToken || !data.otpAuthUri) {
          resetPartialAuth();
          showDialogMsg("Sorry. An unexpected error has occurred.");
          return;
        }

        // 재등록을 취소하면 이 토큰으로 되돌려 인증 단계를 이어간다.
        setPrevOtpToken(mode === OTP_MODE_REREGISTER ? token : "");
        setOtpMode(mode);
        setOtpToken(data.otpToken);
        setOtpAuthUri(data.otpAuthUri);
        setSecretKey(data.secretKey);
        startRemainCountdown(data.remainSeconds);
        setOtpRegisterCode("");
        setOtpRegisterMessage("");
        setIsRegisterOpen(true);
      })
      .catch((error) => handleOtpError(error, "modal"));
  };

  const handleReRegister = () => {
    openRegisterModal(OTP_MODE_REREGISTER, otpToken);
  };

  const handleOtpRegister = () => {
    if (otpSubmittingRef.current) {
      return;
    }
    otpSubmittingRef.current = true;

    api
      .post("/user/otp/register/confirm", {
        otpToken: otpToken,
        code: otpRegisterCode,
      })
      .then((response) => {
        const data = response?.data;

        if (!data || !data.otpToken) {
          resetPartialAuth();
          showDialogMsg("Sorry. An unexpected error has occurred.");
          return;
        }

        // 등록에 쓴 시간만큼 인증 시간이 줄지 않도록 서버가 제한 시간을 다시 기산해 준다.
        setOtpToken(data.otpToken);
        startRemainCountdown(data.remainSeconds);
        setPrevOtpToken("");
        setOtpMode("");
        setOtpAuthUri("");
        setSecretKey("");
        setOtpRegisterCode("");
        setOtpRegisterMessage("");
        enterOtpAuth();
      })
      .catch((error) => handleOtpError(error, "modal"))
      .finally(() => {
        otpSubmittingRef.current = false;
      });
  };

  /*
    등록 창을 닫는다.
    재등록 중이었다면 기존 키로 인증을 이어갈 수 있도록 이전 토큰으로 되돌리고,
    최초 등록 중이었다면 등록을 마치지 않은 것이므로 로그인 화면을 초기화한다.
  */
  const handleRegisterClose = () => {
    if (otpMode === OTP_MODE_REREGISTER && prevOtpToken) {
      setOtpToken(prevOtpToken);
      setPrevOtpToken("");
      setOtpMode("");
      setOtpAuthUri("");
      setSecretKey("");
      setOtpRegisterCode("");
      setOtpRegisterMessage("");
      enterOtpAuth();
      return;
    }

    handleOtpCancel();
  };

  /* ===== OTP 인증 ===== */
  const handleOtpVerify = () => {
    if (otpSubmittingRef.current) {
      return;
    }
    otpSubmittingRef.current = true;

    setOtpMessage("");

    api
      .post("/user/otp/verify", {
        otpToken: otpToken,
        code: otpCode,
      })
      // verify 응답은 step=DONE 응답의 token 과 같은 형태다.
      .then((response) => completeLogin(response?.data))
      .catch((error) => handleOtpError(error, "inline"))
      .finally(() => {
        otpSubmittingRef.current = false;
      });
  };

  /* 취소는 서버를 호출하지 않는다. 화면이 토큰을 버리면 끝이고 이력에도 남기지 않는다. */
  const handleOtpCancel = () => {
    resetPartialAuth();
    setUserId("");
    setUserPwd("");
  };

  /* 화면 타이머가 0 이 되면 서버에 알려 제한 시간 초과 이력을 남긴다. */
  const handleOtpTimeout = () => {
    const expiredToken = otpToken;

    resetPartialAuth();
    setUserPwd("");
    showDialogMsg(t("L1124"));

    if (expiredToken) {
      api
        .post("/user/otp/timeout", { otpToken: expiredToken })
        .catch(() => {});
    }
  };

  /*
    최신 앱(APK) 다운로드. 어떤 파일을 내려줄지는 서버가 앱 관리에 등록된 최신 버전으로 정한다.
    모바일 화면에는 MessageDialog 가 없으므로 실패 처리는 호출하는 쪽에서 넘겨받는다.
  */
  const handleDownload = async (onError) => {
    try {
      const response = await api.post(
          "/common/application/download",
          {},
          { responseType: "blob" }
      );
      // Content-Disposition 헤더에서 파일명 추출
      let fileName = "file";
      const disposition = response.headers["content-disposition"];
      if (disposition) {
          const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (match && match[1]) {
              fileName = decodeURIComponent(match[1].replace(/['"]/g, ""));
          }
      }
      saveBlobAsFile(response.data, fileName);
    } catch (error) {
      onError();
    }
  };

  if (isAndroidDevice()) {
    return (
      <LinkMobile>
        <div className="app_down">
          <p>eVHC</p>
          <dl>
            <a
              href="#"
              onClick={async (e) => {
                e.preventDefault();
                await handleDownload(() => alert("Download failed"));
              }}
            >
              <img src={mobileIcon} alt="mobileIcon" />
            </a>
            <span>Click to download mobile app.</span>
          </dl>
        </div>
      </LinkMobile>
    );
  }

  return (
    <div>
      <SimpleHeader />

      <div style={{ minHeight: "800px" }}>
        <LoginVisualWrap>
          <div className="text_area">
            <div className="title">
              <h1>eVHC Information System</h1>
            </div>
          </div>
        </LoginVisualWrap>

        <LoginInputWrapDiv>
          <ul>
            <li>
              <img src={idIcon} alt="Id" />
              <SearchInput
                value={userId}
                width="320px"
                maxLength={250}
                placeholder={t("L0185")}
                style={{
                  marginLeft: "40px",
                  height: "50px",
                  backgroundColor: "#f6f3f2",
                  fontSize: "15px",
                }}
                onChange={handleIdChange}
                onKeyDown={activeEnter}
                disabled={isPartialAuth}
              ></SearchInput>
            </li>
            <li>
              <img src={pwIcon} alt="pw" />
              <SearchInput
                type="password"
                value={userPwd}
                width="320px"
                maxLength={250}
                placeholder={t("L0027")}
                style={{
                  marginLeft: "40px",
                  height: "50px",
                  backgroundColor: "#f6f3f2",
                  fontSize: "15px",
                }}
                onChange={handlePwdChange}
                onKeyDown={activeEnter}
                disabled={isPartialAuth}
              ></SearchInput>
            </li>
          </ul>
          <LoginButton onClick={handleLogin} disabled={isPartialAuth}>
            Login
          </LoginButton>
        </LoginInputWrapDiv>

        {loginStep === STEP_OTP_AUTH && (
          <OtpAuthInline
            code={otpCode}
            onCodeChange={handleOtpCodeChange}
            onVerify={handleOtpVerify}
            onCancel={handleOtpCancel}
            onReRegister={handleReRegister}
            remainSeconds={remainSeconds}
            message={otpMessage}
          />
        )}

        <LinkWrap>
          <table>
            <colgroup>
              <col style={{ width: "50%" }} />
              <col style={{ width: "50%" }} />
            </colgroup>
            <tbody>
              <tr>
                <td>
                  <Link to="/join/reg-org">{t("L0335")}</Link>
                </td>
                <td>
                  <Link to="/join/unblock">{t("L0032")}</Link>
                </td>
              </tr>
              <tr>
                <td>
                  <Link to="/join/find-info">{t("L0336")}</Link>
                </td>
                <td>
                  <Link to="/join/approval">{t("L0033")}</Link>
                </td>
              </tr>
            </tbody>
          </table>
        </LinkWrap>

        <AppDownWrap>
          <button
            type="button"
            onClick={() => handleDownload(() => showDialogMsg(t("L0957")))}
          >
            <img src={mobileIcon} alt="App" />
            Download Mobile App (APK)
          </button>
        </AppDownWrap>
      </div>

      {isRegisterOpen && (
        <OtpRegisterModal
          mode={otpMode}
          otpAuthUri={otpAuthUri}
          secretKey={secretKey}
          code={otpRegisterCode}
          onCodeChange={handleOtpRegisterCodeChange}
          onRegister={handleOtpRegister}
          onClose={handleRegisterClose}
          remainSeconds={remainSeconds}
          message={otpRegisterMessage}
        />
      )}

      {isDialogOpen && (
        <MessageDialog title={"Information"} message={dialogMsg}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}

      {isDialogOpen2 && (
        <MessageDialog title={t("L0339")} message={dialogMsg2}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm2}
          ></FunctionButton>
        </MessageDialog>
      )}

      {/* 로그인 화면 팝업 공지 (비로그인 상태에서 공개 API로 조회) */}
      <NoticePopupList target={POPUP_TARGET.LOGIN} />
      <Footer />
    </div>
  );
};

export default LoginPage;
